<template>
  <el-dialog :visible.sync="visible"
             :title="!dataForm.id ? $t('add') : $t('update')"
             :close-on-click-modal="false"
             :close-on-press-escape="false">

    <div class="restrict-content">
      <div class="add-div"
           @click="addRestrict()">
        +
      </div>
      <div class="restrict-div"
           v-for="(item,index) in restList"
           :key="index">
        <div v-if="index == 0">
          从 &nbsp;
          <el-input type="text"
                    v-model="item.page" />&nbsp;页 &nbsp;
          <el-input type="text"
                    v-model="item.col" />&nbsp;列 &nbsp;
          <el-input type="text"
                    v-model="item.row" />&nbsp;行&nbsp;&nbsp;&nbsp;&nbsp;写保护&nbsp;
          <el-input class="protect-input"
                    type="text"
                    v-model="item.cols" />&nbsp;列&nbsp;&nbsp;&nbsp;<el-radio v-model="item.type"
                    label="1">组织编号</el-radio>
          <el-radio v-model="item.type"
                    label="2">NSC No.</el-radio>
        </div>
        <div class="add-template"
             v-else>
          <div class="del-btn"
               @click="delRestrict(index)">-</div>
          从 &nbsp;
          <el-input type="text"
                    v-model="item.page" />&nbsp;页 &nbsp;
          <el-input type="text"
                    v-model="item.col" />&nbsp;列 &nbsp;
          <el-input type="text"
                    v-model="item.row" />&nbsp;行&nbsp;&nbsp;&nbsp;&nbsp;写保护&nbsp;
          <el-input class="protect-input"
                    type="text"
                    v-model="item.cols" />&nbsp;列&nbsp;&nbsp;&nbsp;<el-radio v-model="item.type"
                    label="1">组织编号</el-radio>
          <el-radio v-model="item.type"
                    label="2">NSC No.</el-radio>
        </div>
      </div>
    </div>
    <div class="upload-btn">
      <el-upload class="upload-demo"
                 :action="action"
                 :headers="myHeader"
                 :auto-upload="true"
                 :limit="1"
                 :on-remove="handleRemove"
                 :before-remove="beforeRemove"
                 :file-list="fileList">
        <el-button size="small"
                   type="primary">上传文件</el-button>
        <div slot="tip"
             class="el-upload__tip">只能上传excel文件，且不超过5mb</div>
      </el-upload>
      <el-button style="float:right;" type="primary"
                 size="small"
                 @click="upload()">{{ $t('bulkmail.upload') }}</el-button>
    </div>
    <el-table v-loading="dataListLoading"
              :data="dataList"
              border
              style="width: 100%;">
      <el-table-column type="index"
                       width="50"
                       :label="$t('bulkmail.no')"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="attachmentName"
                       :label="$t('bulkmail.fileName')"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="orgId"
                       :label="$t('bulkmail.orgIdAndNSCNO')"
                       header-align="center"
                       align="center"></el-table-column>
    </el-table>
    <el-pagination :current-page="page"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="limit"
                   :total="total"
                   layout="total, sizes, prev, pager, next, jumper"
                   @size-change="pageSizeChangeHandle"
                   @current-change="pageCurrentChangeHandle">
    </el-pagination>
  </el-dialog>
</template>

<script>
// import debounce from 'lodash/debounce'
export default {
  data() {
    return {
      visible: false,
      action: '',
      dataForm: {
        id: '',
        page: ''
      },
      fileList: [],
      dataListLoading: false,
      page: 1, // 当前页码
      limit: 5, // 每页数
      total: 0, // 总条数
      dataList: [{
        attachmentName: '20537_新建 工作表 (1).xlsx',
        orgId: '20537'
      },{
        attachmentName: '20537_新建 工作表 (2).xlsx',
        orgId: '20537'
      },{
        attachmentName: '20537_新建 工作表 (3).xlsx',
        orgId: '20537'
      },{
        attachmentName: '20537_新建 工作表 (4).xlsx',
        orgId: '20537'
      },{
        attachmentName: '20537_新建 工作表 (5).xlsx',
        orgId: '20537'
      }],
      radio: null,
      restList: [{
        page: null,
        col: null,
        row: null,
        cols: null,
        type: null
      }],
      myHeader: { token: '' }, // token
      url: '/sys/commmail/uploadAttachment'
    }
  },
  computed: {
    dataRule() {
      return {
        username: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  activated() {
    console.log('activated')
  },
  methods: {
    init() {
      this.visible = true
      this.action = `${window.SITE_CONFIG['apiURL']}` + this.url
      this.myHeader.token = this.getStorage(this.GLOBAL.TOKEN)
      this.$nextTick(() => {
        console.log('nextTick')
      })
    },
    /* handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    }, */
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    upload() {
      this.checkRestList()
    },
    pageSizeChangeHandle() {
      console.log('pageSizeChangeHandle')
    },
    pageCurrentChangeHandle() {
      console.log('pageCurrentChangeHandle')
    },
    addRestrict() {
      this.restList.push({
        page: null,
        col: null,
        row: null,
        cols: null,
        type: null
      })
    },
    delRestrict(index) {
      this.restList.splice(index, 1)
    },
    checkRestList() {
      var canSubmit = true
      var errorMsg = ''
      this.restList.forEach(element => {
        if (element.type == null) {
          errorMsg = '组织编号或NSC No类型必须选择一项'
          canSubmit = false
        }
        if ((element.page == null || element.page == '')
          && (element.col == null || element.col == '')
          && (element.row == null || element.row == '')
          && (element.cols == null || element.cols == '')) {
          errorMsg = '条件不能都为空'
          canSubmit = false
        }
      });
      if (!canSubmit) {
        this.$alert(errorMsg)
        return false
      } else {
        this.checkAndRest()
      }
    },
    checkAndRest() {
      this.$confirm('检查通过，开始拆分！', '提示', {
        confirmButtonText: '确定',
        type: 'success'
      }).then(() => {
        this.visible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
.restrict-content {
  position: relative;
  margin-top: 20px;
  margin-bottom: 40px;
  .add-div {
    position: absolute;
    padding: 10px;
    background: #1c69d3;
    color: #fff;
    right: 0;
    border-radius: 4px;
    cursor: pointer;
    width: 34px;
    text-align: center;
  }
}
.restrict-div {
  margin: 10px 0;
  .el-input {
    width: 30px;
  }
}
.protect-input.el-input {
  width: 60px;
}
.upload-btn {
  margin-top: 20px;
  margin-bottom: 40px;
}
.add-template {
  position: relative;
}
.del-btn {
  position: absolute;
  padding: 10px;
  background: #999;
  color: #fff;
  right: 0;
  border-radius: 4px;
  cursor: pointer;
  width: 34px;
  text-align: center;
}
.upload-demo{
  display: inline-block;
}
</style>
